import { render, staticRenderFns } from "./DistrictCaseStatus.vue?vue&type=template&id=027f61c0"
import script from "./DistrictCaseStatus.vue?vue&type=script&lang=js"
export * from "./DistrictCaseStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports